import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { imageDelete, ImageInfo } from "./imageSlice";
import { ObjectTarget } from "../../app/permissions";
import { performaImageReview } from "./imageReviewSlice";

export interface ImagesState {
    state: LoadStateInfo;
    request?: RetrieveImagesRequest;
    list?: ImageInfo[];
}

const initialState: ImagesState = {
    state: notStarted(),
};

export interface RetrieveImagesRequest {
    targetType: ObjectTarget;
    targetId: string;
}

export const retrieveImages = createAsyncThunk(
    "retrieveImages",
    async (params: RetrieveImagesRequest, thunkAPI) => {
        console.debug("retrieve schools");

        const response = await fetch(`${getBackendUrl()}/api/image/list`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(params),
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    }
);


export const imagesSlice = createSlice({
    name: "imagesSlice",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        check: (state, action: PayloadAction<RetrieveImagesRequest>) => {
            if (state.request?.targetType != action.payload.targetType || state.request?.targetId != action.payload.targetId) {
                state.state = notStarted();
                state.request = action.payload;
            }
        },
        clean: (state) => {
            state.state = notStarted();
            state.list = undefined;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(retrieveImages.pending, (state, /* action */) => {
                state.state = loading();
                state.list = undefined;
            })
            .addCase(retrieveImages.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
                state.list = action.payload;
                state.list?.sort((a, b) => -(a.createdAt || "").localeCompare(b.createdAt || ""));
            })
            .addCase(retrieveImages.rejected, (state, action) => {
                state.state = error(action);
            })
            .addCase(performaImageReview.fulfilled, (state, /* action */) => {
                state.state = notStarted();
                state.list = undefined;
            })
            .addCase(imageDelete.fulfilled, (state) => {
                state.state = notStarted();
                state.list = undefined;
            })
            ;
    },
});

// export const { } = imagesSlice.actions;

export const selectImages = (state: RootState) => state.images;

export default imagesSlice.reducer;
